var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _circle81, _circle82, _circle83, _circle84, _circle85, _circle86, _circle87, _circle88, _circle89, _circle90, _circle91, _circle92, _circle93, _circle94, _circle95, _circle96, _circle97, _circle98, _circle99, _circle100, _circle101, _circle102, _circle103, _circle104, _circle105, _circle106, _circle107, _circle108, _circle109, _circle110, _circle111, _circle112, _circle113, _circle114, _circle115, _circle116, _circle117, _circle118, _circle119, _circle120, _circle121, _circle122, _circle123, _circle124, _circle125, _circle126, _circle127, _circle128, _circle129, _circle130, _circle131, _circle132, _circle133, _circle134, _circle135, _circle136, _circle137, _circle138, _circle139, _circle140, _circle141, _circle142, _circle143, _circle144, _circle145, _circle146, _circle147, _circle148, _circle149, _circle150, _circle151, _circle152, _circle153, _circle154, _circle155, _circle156, _circle157, _circle158, _circle159, _circle160, _circle161, _circle162, _circle163, _circle164, _circle165, _circle166, _circle167, _circle168, _circle169, _circle170, _circle171, _circle172, _circle173, _circle174, _circle175, _circle176, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup39491(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 268,
    height: 818,
    viewBox: "0 0 268 818",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M333.768 711.895C305.12 715.126 248.492 717.468 251.159 700.993C254.493 680.399 285.257 673.114 315.079 665.149C344.901 657.185 376.94 672.616 363.947 635.933C350.955 599.251 136.334 575.221 243.731 545.844C351.129 516.467 462.818 546.432 389.863 476.921C316.908 407.409 161.313 369.006 199.998 320.435C238.683 271.863 563.943 380.444 463.595 220.228",
    stroke: "black",
    strokeWidth: 1.47128
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 266.172 266.522)",
    fill: "url(#paint0_linear_312_708)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 266.172 266.522)",
    fill: "url(#paint1_linear_312_708)",
    fillOpacity: 0.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 252.209 270.693)",
    fill: "url(#paint2_linear_312_708)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 252.209 270.693)",
    fill: "url(#paint3_linear_312_708)",
    fillOpacity: 0.2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 237.965 273.791)",
    fill: "url(#paint4_linear_312_708)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 237.965 273.791)",
    fill: "url(#paint5_linear_312_708)",
    fillOpacity: 0.2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 223.564 276.093)",
    fill: "url(#paint6_linear_312_708)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 223.564 276.093)",
    fill: "url(#paint7_linear_312_708)",
    fillOpacity: 0.2
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 209.074 277.801)",
    fill: "url(#paint8_linear_312_708)"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 209.074 277.801)",
    fill: "url(#paint9_linear_312_708)",
    fillOpacity: 0.2
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 194.539 279.067)",
    fill: "url(#paint10_linear_312_708)"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 194.539 279.067)",
    fill: "url(#paint11_linear_312_708)",
    fillOpacity: 0.2
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 179.973 280.015)",
    fill: "url(#paint12_linear_312_708)"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 179.973 280.015)",
    fill: "url(#paint13_linear_312_708)",
    fillOpacity: 0.2
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 165.398 280.742)",
    fill: "url(#paint14_linear_312_708)"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 165.398 280.742)",
    fill: "url(#paint15_linear_312_708)",
    fillOpacity: 0.2
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 150.814 281.338)",
    fill: "url(#paint16_linear_312_708)"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 150.814 281.338)",
    fill: "url(#paint17_linear_312_708)",
    fillOpacity: 0.2
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 136.234 281.886)",
    fill: "url(#paint18_linear_312_708)"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 136.234 281.886)",
    fill: "url(#paint19_linear_312_708)",
    fillOpacity: 0.2
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 121.65 282.469)",
    fill: "url(#paint20_linear_312_708)"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 121.65 282.469)",
    fill: "url(#paint21_linear_312_708)",
    fillOpacity: 0.2
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 107.076 283.183)",
    fill: "url(#paint22_linear_312_708)"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 107.076 283.183)",
    fill: "url(#paint23_linear_312_708)",
    fillOpacity: 0.2
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 92.5272 284.141)",
    fill: "url(#paint24_linear_312_708)"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 92.5272 284.141)",
    fill: "url(#paint25_linear_312_708)",
    fillOpacity: 0.2
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 78.0156 285.487)",
    fill: "url(#paint26_linear_312_708)"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 78.0156 285.487)",
    fill: "url(#paint27_linear_312_708)",
    fillOpacity: 0.2
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 63.582 287.426)",
    fill: "url(#paint28_linear_312_708)"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 63.582 287.426)",
    fill: "url(#paint29_linear_312_708)",
    fillOpacity: 0.2
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 49.3496 290.265)",
    fill: "url(#paint30_linear_312_708)"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 49.3496 290.265)",
    fill: "url(#paint31_linear_312_708)",
    fillOpacity: 0.2
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 35.5762 294.5)",
    fill: "url(#paint32_linear_312_708)"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 35.5762 294.5)",
    fill: "url(#paint33_linear_312_708)",
    fillOpacity: 0.2
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 22.2012 301.425)",
    fill: "url(#paint34_linear_312_708)"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 22.2012 301.425)",
    fill: "url(#paint35_linear_312_708)",
    fillOpacity: 0.2
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 12.1289 311.791)",
    fill: "url(#paint36_linear_312_708)"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 12.1289 311.791)",
    fill: "url(#paint37_linear_312_708)",
    fillOpacity: 0.2
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 5.92969 325.002)",
    fill: "url(#paint38_linear_312_708)"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 5.92969 325.002)",
    fill: "url(#paint39_linear_312_708)",
    fillOpacity: 0.2
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 5.07617 339.572)",
    fill: "url(#paint40_linear_312_708)"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 5.07617 339.572)",
    fill: "url(#paint41_linear_312_708)",
    fillOpacity: 0.2
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 10.3185 353.192)",
    fill: "url(#paint42_linear_312_708)"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 10.3185 353.192)",
    fill: "url(#paint43_linear_312_708)",
    fillOpacity: 0.2
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 19.2871 364.704)",
    fill: "url(#paint44_linear_312_708)"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 19.2871 364.704)",
    fill: "url(#paint45_linear_312_708)",
    fillOpacity: 0.2
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 30.0332 374.582)",
    fill: "url(#paint46_linear_312_708)"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 30.0332 374.582)",
    fill: "url(#paint47_linear_312_708)",
    fillOpacity: 0.2
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 41.6582 383.406)",
    fill: "url(#paint48_linear_312_708)"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 41.6582 383.406)",
    fill: "url(#paint49_linear_312_708)",
    fillOpacity: 0.2
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 53.7635 391.568)",
    fill: "url(#paint50_linear_312_708)"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 53.7635 391.568)",
    fill: "url(#paint51_linear_312_708)",
    fillOpacity: 0.2
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 66.1211 399.329)",
    fill: "url(#paint52_linear_312_708)"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 66.1211 399.329)",
    fill: "url(#paint53_linear_312_708)",
    fillOpacity: 0.2
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 78.6133 406.869)",
    fill: "url(#paint54_linear_312_708)"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 78.6133 406.869)",
    fill: "url(#paint55_linear_312_708)",
    fillOpacity: 0.2
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 91.1641 414.325)",
    fill: "url(#paint56_linear_312_708)"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 91.1641 414.325)",
    fill: "url(#paint57_linear_312_708)",
    fillOpacity: 0.2
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 103.695 421.806)",
    fill: "url(#paint58_linear_312_708)"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 103.695 421.806)",
    fill: "url(#paint59_linear_312_708)",
    fillOpacity: 0.2
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 116.152 429.41)",
    fill: "url(#paint60_linear_312_708)"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 116.152 429.41)",
    fill: "url(#paint61_linear_312_708)",
    fillOpacity: 0.2
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 128.48 437.222)",
    fill: "url(#paint62_linear_312_708)"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 128.48 437.222)",
    fill: "url(#paint63_linear_312_708)",
    fillOpacity: 0.2
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 140.617 445.332)",
    fill: "url(#paint64_linear_312_708)"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 140.617 445.332)",
    fill: "url(#paint65_linear_312_708)",
    fillOpacity: 0.2
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 152.486 453.826)",
    fill: "url(#paint66_linear_312_708)"
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 152.486 453.826)",
    fill: "url(#paint67_linear_312_708)",
    fillOpacity: 0.2
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 163.998 462.796)",
    fill: "url(#paint68_linear_312_708)"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 163.998 462.796)",
    fill: "url(#paint69_linear_312_708)",
    fillOpacity: 0.2
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 175.041 472.337)",
    fill: "url(#paint70_linear_312_708)"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 175.041 472.337)",
    fill: "url(#paint71_linear_312_708)",
    fillOpacity: 0.2
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 185.473 482.548)",
    fill: "url(#paint72_linear_312_708)"
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 185.473 482.548)",
    fill: "url(#paint73_linear_312_708)",
    fillOpacity: 0.2
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 194.691 493.003)",
    fill: "url(#paint74_linear_312_708)"
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 194.691 493.003)",
    fill: "url(#paint75_linear_312_708)",
    fillOpacity: 0.2
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 203.469 504.658)",
    fill: "url(#paint76_linear_312_708)"
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 203.469 504.658)",
    fill: "url(#paint77_linear_312_708)",
    fillOpacity: 0.2
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 210.697 517.343)",
    fill: "url(#paint78_linear_312_708)"
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 210.697 517.343)",
    fill: "url(#paint79_linear_312_708)",
    fillOpacity: 0.2
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 213.729 531.627)",
    fill: "url(#paint80_linear_312_708)"
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 213.729 531.627)",
    fill: "url(#paint81_linear_312_708)",
    fillOpacity: 0.2
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 206.809 544.477)",
    fill: "url(#paint82_linear_312_708)"
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 206.809 544.477)",
    fill: "url(#paint83_linear_312_708)",
    fillOpacity: 0.2
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 194.189 551.801)",
    fill: "url(#paint84_linear_312_708)"
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 194.189 551.801)",
    fill: "url(#paint85_linear_312_708)",
    fillOpacity: 0.2
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 180.379 556.525)",
    fill: "url(#paint86_linear_312_708)"
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 180.379 556.525)",
    fill: "url(#paint87_linear_312_708)",
    fillOpacity: 0.2
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 166.246 560.178)",
    fill: "url(#paint88_linear_312_708)"
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 166.246 560.178)",
    fill: "url(#paint89_linear_312_708)",
    fillOpacity: 0.2
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 152.008 563.385)",
    fill: "url(#paint90_linear_312_708)"
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 152.008 563.385)",
    fill: "url(#paint91_linear_312_708)",
    fillOpacity: 0.2
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 137.736 566.457)",
    fill: "url(#paint92_linear_312_708)"
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 137.736 566.457)",
    fill: "url(#paint93_linear_312_708)",
    fillOpacity: 0.2
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 123.484 569.583)",
    fill: "url(#paint94_linear_312_708)"
  })), _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 123.484 569.583)",
    fill: "url(#paint95_linear_312_708)",
    fillOpacity: 0.2
  })), _circle97 || (_circle97 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 109.264 572.885)",
    fill: "url(#paint96_linear_312_708)"
  })), _circle98 || (_circle98 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 109.264 572.885)",
    fill: "url(#paint97_linear_312_708)",
    fillOpacity: 0.2
  })), _circle99 || (_circle99 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 95.1152 576.458)",
    fill: "url(#paint98_linear_312_708)"
  })), _circle100 || (_circle100 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 95.1152 576.458)",
    fill: "url(#paint99_linear_312_708)",
    fillOpacity: 0.2
  })), _circle101 || (_circle101 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 81.0566 580.377)",
    fill: "url(#paint100_linear_312_708)"
  })), _circle102 || (_circle102 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 81.0566 580.377)",
    fill: "url(#paint101_linear_312_708)",
    fillOpacity: 0.2
  })), _circle103 || (_circle103 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 67.1154 584.7)",
    fill: "url(#paint102_linear_312_708)"
  })), _circle104 || (_circle104 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 67.1154 584.7)",
    fill: "url(#paint103_linear_312_708)",
    fillOpacity: 0.2
  })), _circle105 || (_circle105 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 53.3242 589.482)",
    fill: "url(#paint104_linear_312_708)"
  })), _circle106 || (_circle106 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 53.3242 589.482)",
    fill: "url(#paint105_linear_312_708)",
    fillOpacity: 0.2
  })), _circle107 || (_circle107 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 39.7247 594.767)",
    fill: "url(#paint106_linear_312_708)"
  })), _circle108 || (_circle108 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 39.7247 594.767)",
    fill: "url(#paint107_linear_312_708)",
    fillOpacity: 0.2
  })), _circle109 || (_circle109 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 27.873 599.903)",
    fill: "url(#paint108_linear_312_708)"
  })), _circle110 || (_circle110 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 27.873 599.903)",
    fill: "url(#paint109_linear_312_708)",
    fillOpacity: 0.2
  })), _circle111 || (_circle111 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 14.9082 606.594)",
    fill: "url(#paint110_linear_312_708)"
  })), _circle112 || (_circle112 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 14.9082 606.594)",
    fill: "url(#paint111_linear_312_708)",
    fillOpacity: 0.2
  })), _circle113 || (_circle113 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 3.16211 615.32)",
    fill: "url(#paint112_linear_312_708)"
  })), _circle114 || (_circle114 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 3.16211 615.32)",
    fill: "url(#paint113_linear_312_708)",
    fillOpacity: 0.2
  })), _circle115 || (_circle115 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 0.117188 629.573)",
    fill: "url(#paint114_linear_312_708)"
  })), _circle116 || (_circle116 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 0.117188 629.573)",
    fill: "url(#paint115_linear_312_708)",
    fillOpacity: 0.2
  })), _circle117 || (_circle117 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 11.379 638.832)",
    fill: "url(#paint116_linear_312_708)"
  })), _circle118 || (_circle118 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 11.379 638.832)",
    fill: "url(#paint117_linear_312_708)",
    fillOpacity: 0.2
  })), _circle119 || (_circle119 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 24.6681 644.875)",
    fill: "url(#paint118_linear_312_708)"
  })), _circle120 || (_circle120 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 24.6681 644.875)",
    fill: "url(#paint119_linear_312_708)",
    fillOpacity: 0.2
  })), _circle121 || (_circle121 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 38.4082 649.792)",
    fill: "url(#paint120_linear_312_708)"
  })), _circle122 || (_circle122 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 38.4082 649.792)",
    fill: "url(#paint121_linear_312_708)",
    fillOpacity: 0.2
  })), _circle123 || (_circle123 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 52.3203 654.21)",
    fill: "url(#paint122_linear_312_708)"
  })), _circle124 || (_circle124 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 52.3203 654.21)",
    fill: "url(#paint123_linear_312_708)",
    fillOpacity: 0.2
  })), _circle125 || (_circle125 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 66.2891 658.435)",
    fill: "url(#paint124_linear_312_708)"
  })), _circle126 || (_circle126 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 66.2891 658.435)",
    fill: "url(#paint125_linear_312_708)",
    fillOpacity: 0.2
  })), _circle127 || (_circle127 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 80.2539 662.675)",
    fill: "url(#paint126_linear_312_708)"
  })), _circle128 || (_circle128 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 80.2539 662.675)",
    fill: "url(#paint127_linear_312_708)",
    fillOpacity: 0.2
  })), _circle129 || (_circle129 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 94.1581 667.119)",
    fill: "url(#paint128_linear_312_708)"
  })), _circle130 || (_circle130 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 94.1581 667.119)",
    fill: "url(#paint129_linear_312_708)",
    fillOpacity: 0.2
  })), _circle131 || (_circle131 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 107.912 671.991)",
    fill: "url(#paint130_linear_312_708)"
  })), _circle132 || (_circle132 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 107.912 671.991)",
    fill: "url(#paint131_linear_312_708)",
    fillOpacity: 0.2
  })), _circle133 || (_circle133 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 121.371 677.633)",
    fill: "url(#paint132_linear_312_708)"
  })), _circle134 || (_circle134 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 121.371 677.633)",
    fill: "url(#paint133_linear_312_708)",
    fillOpacity: 0.2
  })), _circle135 || (_circle135 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 134.148 684.701)",
    fill: "url(#paint134_linear_312_708)"
  })), _circle136 || (_circle136 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 134.148 684.701)",
    fill: "url(#paint135_linear_312_708)",
    fillOpacity: 0.2
  })), _circle137 || (_circle137 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 144.725 694.75)",
    fill: "url(#paint136_linear_312_708)"
  })), _circle138 || (_circle138 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 144.725 694.75)",
    fill: "url(#paint137_linear_312_708)",
    fillOpacity: 0.2
  })), _circle139 || (_circle139 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 148.424 708.045)",
    fill: "url(#paint138_linear_312_708)"
  })), _circle140 || (_circle140 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 148.424 708.045)",
    fill: "url(#paint139_linear_312_708)",
    fillOpacity: 0.2
  })), _circle141 || (_circle141 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 147.955 722.626)",
    fill: "url(#paint140_linear_312_708)"
  })), _circle142 || (_circle142 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 147.955 722.626)",
    fill: "url(#paint141_linear_312_708)",
    fillOpacity: 0.2
  })), _circle143 || (_circle143 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 138.348 733.612)",
    fill: "url(#paint142_linear_312_708)"
  })), _circle144 || (_circle144 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 138.348 733.612)",
    fill: "url(#paint143_linear_312_708)",
    fillOpacity: 0.2
  })), _circle145 || (_circle145 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 124.166 737.06)",
    fill: "url(#paint144_linear_312_708)"
  })), _circle146 || (_circle146 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 124.166 737.06)",
    fill: "url(#paint145_linear_312_708)",
    fillOpacity: 0.2
  })), _circle147 || (_circle147 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 109.756 739.362)",
    fill: "url(#paint146_linear_312_708)"
  })), _circle148 || (_circle148 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 109.756 739.362)",
    fill: "url(#paint147_linear_312_708)",
    fillOpacity: 0.2
  })), _circle149 || (_circle149 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 95.6836 743.237)",
    fill: "url(#paint148_linear_312_708)"
  })), _circle150 || (_circle150 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 95.6836 743.237)",
    fill: "url(#paint149_linear_312_708)",
    fillOpacity: 0.2
  })), _circle151 || (_circle151 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 82.3555 748.892)",
    fill: "url(#paint150_linear_312_708)"
  })), _circle152 || (_circle152 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 82.3555 748.892)",
    fill: "url(#paint151_linear_312_708)",
    fillOpacity: 0.2
  })), _circle153 || (_circle153 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 69.0234 754.84)",
    fill: "url(#paint152_linear_312_708)"
  })), _circle154 || (_circle154 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 69.0234 754.84)",
    fill: "url(#paint153_linear_312_708)",
    fillOpacity: 0.2
  })), _circle155 || (_circle155 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 55.9727 761.369)",
    fill: "url(#paint154_linear_312_708)"
  })), _circle156 || (_circle156 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 55.9727 761.369)",
    fill: "url(#paint155_linear_312_708)",
    fillOpacity: 0.2
  })), _circle157 || (_circle157 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 43.5391 769.012)",
    fill: "url(#paint156_linear_312_708)"
  })), _circle158 || (_circle158 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 43.5391 769.012)",
    fill: "url(#paint157_linear_312_708)",
    fillOpacity: 0.2
  })), _circle159 || (_circle159 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 32.4395 778.488)",
    fill: "url(#paint158_linear_312_708)"
  })), _circle160 || (_circle160 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 32.4395 778.488)",
    fill: "url(#paint159_linear_312_708)",
    fillOpacity: 0.2
  })), _circle161 || (_circle161 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 24.1484 790.5)",
    fill: "url(#paint160_linear_312_708)"
  })), _circle162 || (_circle162 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 24.1484 790.5)",
    fill: "url(#paint161_linear_312_708)",
    fillOpacity: 0.2
  })), _circle163 || (_circle163 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 21.7227 803.957)",
    fill: "url(#paint162_linear_312_708)"
  })), _circle164 || (_circle164 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 21.7227 803.957)",
    fill: "url(#paint163_linear_312_708)",
    fillOpacity: 0.2
  })), _circle165 || (_circle165 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 34.4414 811.028)",
    fill: "url(#paint164_linear_312_708)"
  })), _circle166 || (_circle166 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 34.4414 811.028)",
    fill: "url(#paint165_linear_312_708)",
    fillOpacity: 0.2
  })), _circle167 || (_circle167 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 49.0156 811.821)",
    fill: "url(#paint166_linear_312_708)"
  })), _circle168 || (_circle168 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 49.0156 811.821)",
    fill: "url(#paint167_linear_312_708)",
    fillOpacity: 0.2
  })), _circle169 || (_circle169 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 63.5742 810.804)",
    fill: "url(#paint168_linear_312_708)"
  })), _circle170 || (_circle170 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 63.5742 810.804)",
    fill: "url(#paint169_linear_312_708)",
    fillOpacity: 0.2
  })), _circle171 || (_circle171 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 78.035 808.828)",
    fill: "url(#paint170_linear_312_708)"
  })), _circle172 || (_circle172 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 78.035 808.828)",
    fill: "url(#paint171_linear_312_708)",
    fillOpacity: 0.2
  })), _circle173 || (_circle173 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 92.3906 806.185)",
    fill: "url(#paint172_linear_312_708)"
  })), _circle174 || (_circle174 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 92.3906 806.185)",
    fill: "url(#paint173_linear_312_708)",
    fillOpacity: 0.2
  })), _circle175 || (_circle175 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 106.623 802.959)",
    fill: "url(#paint174_linear_312_708)"
  })), _circle176 || (_circle176 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7719,
    cy: 85.7719,
    r: 85.7719,
    transform: "matrix(0.929339 0.369229 0.369229 -0.929339 106.623 802.959)",
    fill: "url(#paint175_linear_312_708)",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_312_708",
    x1: 81.8297,
    y1: -16.4848,
    x2: 83.2397,
    y2: 171.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180503,
    stopColor: "#FDC47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.310503,
    stopColor: "#F6EB90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460503,
    stopColor: "#BDDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660503,
    stopColor: "#A3CAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830503,
    stopColor: "#9BB3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_312_708",
    x1: 85.7719,
    y1: 0,
    x2: 85.7719,
    y2: 171.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222945,
    stopColor: "#FE697B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup39491);
export default __webpack_public_path__ + "static/media/Group 39491.d430dd269c37592f7add4ac6e43b3f30.svg";
export { ForwardRef as ReactComponent };